var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDb30(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.353 22.4292C6.41413 23.2384 6.75463 23.7106 7.70188 23.6918C14.306 23.5849 16.0396 15.5779 11.9593 11.8111C11.3045 11.2092 10.5103 10.7127 9.55175 10.3771C9.06988 10.2064 8.276 9.96045 7.59913 9.96045C7.0175 9.96045 6.5225 10.1446 6.39388 10.7243C6.155 11.8313 6.26638 21.3312 6.353 22.4292Z",
    fill: "url(#paint0_linear_3925_19880)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5672 2.5C15.0359 2.5 14.5889 2.671 14.47 3.19675C14.2521 4.198 14.3571 12.8249 14.4321 13.825C14.4895 14.5555 14.7962 14.9834 15.6561 14.9714C21.6539 14.8705 23.2319 7.60112 19.5265 4.18187C18.9329 3.63512 18.2046 3.18475 17.3421 2.881C16.9019 2.72388 16.183 2.5 15.5672 2.5Z",
    fill: "url(#paint1_linear_3925_19880)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8214 10.9613C15.5424 12.2224 15.677 23.058 15.773 24.3154C15.8469 25.2398 16.2286 25.7711 17.3075 25.7554C24.848 25.6346 26.8299 16.4978 22.1743 12.1995C21.4303 11.5136 20.5126 10.9466 19.4285 10.5653C18.8758 10.3684 17.969 10.0879 17.2003 10.0879C16.5335 10.0879 15.9658 10.299 15.8214 10.9613Z",
    fill: "url(#paint2_linear_3925_19880)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3925_19880",
    x1: 6.25,
    y1: 23.6924,
    x2: 14.1496,
    y2: 23.6924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CB292B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47920"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3925_19880",
    x1: 14.338,
    y1: 15.0816,
    x2: 21.6527,
    y2: 15.1047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1CB0E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0462B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3925_19880",
    x1: 14.8597,
    y1: 27.2841,
    x2: 25.6621,
    y2: 27.3182,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC53F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009B56"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDb30);
export default __webpack_public_path__ + "static/media/DB금융투자-30.102a2cdc07299743f534671fed39cbe8.svg";
export { ForwardRef as ReactComponent };